import { Providers } from './src/components/Layout/Providers';
import type { GatsbyBrowser } from 'gatsby';

/** This wraps ALL of Gatsby with these providers. */
export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => (
  <Providers>{element}</Providers>
);
